// This function allow to reference async chunks
__webpack_require__.u = function(chunkId) {
	// return url for filenames based on template
	return "js/" + chunkId + "." + {"45":"67d4bfe7","523":"dc5c93c1","752":"7e5c987a","938":"275e0ced"}[chunkId] + ".js";
};